import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f51acca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ion-padding-horizontal" }
const _hoisted_2 = { class: "ion-margin-top ion-margin-start" }
const _hoisted_3 = {
  key: 0,
  class: "ion-padding-top"
}
const _hoisted_4 = {
  key: 1,
  class: "ion-margin-vertical"
}
const _hoisted_5 = {
  key: 2,
  class: "ion-margin-vertical"
}
const _hoisted_6 = {
  key: 3,
  class: "ion-margin-vertical"
}
const _hoisted_7 = {
  key: 4,
  class: "ion-margin-vertical"
}
const _hoisted_8 = {
  key: 0,
  class: "ion-padding"
}
const _hoisted_9 = { class: "ion-padding" }

import {
  CourseModelProps,
  ModelProposition,
  User,
  LearningArea,
  CourseModel,
  GrowthArea,
  CustomElement,
  PropositionRequiredKeys,
  Teaching,
  StudyAddress,
  LearningSession,
  PropositionTitles,
  PropositionCharacteristics1,
  //PropositionCharacteristics2,
  OrderedCardsList,
  GeneralCardElements,
  TeachingProps,
  AccessProposition,
  LearningContext,
  Teacher,
  TeacherProps,
  TeacherProposition,
  PropositionDescription,
  PropositionExpectedLearningResults,
  PropositionActivities,
  PropositionCriterions,
  Course,
  AccessObject,
  PropositionTeacher,
  PropositionSpecificInformation,
  GrowthAreaProps,
  AlertInformation,
  AdminProjectClass,
  PropositionListsKeys,
  PropositionActions,
  ImageDescriptor,
} from "@/types";
import {
  executeLink,
  getAviableLanguages,
  getCurrentElement,
  getCurrentLanguage,
  getCustomMessage,
  getIcon,
  getLearningContexts,
  numberToSection,
  uploadMultipleImages,
} from "@/utils";
import {
  IonAlert,
  IonCard,
  IonCardHeader,
  IonCardContent,
  IonCardTitle,
  IonGrid,
  IonRow,
  IonCol,
  IonInput,
  IonButton,
  IonText,
  IonCheckbox,
  IonList,
  IonItem,
  IonReorderGroup,
  IonReorder,
} from "@ionic/vue";
import { reactive, ref, Ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

type AvailableModal = "error" | "teacher_info" | "confirm" | "success";
type CardsListTypes = "access" | "teachers" | SimpleListTypes;
type SimpleListTypes = "growth_areas" | "teachings";
type SimpleList<T> = {
  available: T[];
  selected: T[];
};


export default /*#__PURE__*/_defineComponent({
  __name: 'CourseProposition',
  async setup(__props) {

let __temp: any, __restore: any

const modelToString = (model: CourseModel) => model.toString();
const learningAreaToString = (learning_area: LearningArea) =>
  learning_area[`${language}_title`];
/*const growthAreaToString = (growth_area: GrowthArea) =>
  growth_area[`${language}_title`];*/
const go = (direction: boolean) => {
  if (direction && current_page_index.value < pages.length - 1) {
    current_page_index.value += 1;
  } else if (!direction && current_page_index.value > 0) {
    current_page_index.value -= 1;
  }
};
const checkAndWarn = () => {
  const missing_information = course_proposition.check(action.value);
  const information_keys = Object.keys(
    missing_information
  ) as PropositionRequiredKeys[];

  let outcome = true;

  if (information_keys.length > 0) {
    setupModalAndOpen("error", missing_information[information_keys[0]]);
    current_page_index.value = course_proposition.getKeyIndex(
      information_keys[0]
    );
    //<!-- TODO (5): Cambiare colori a componenti per segnalare errori
    outcome = false;
  }

  return outcome;
};
const checkAndConfirm = () => {
  if (checkAndWarn()) {
    setupModalAndOpen("confirm");
  }
};
const propose = () => {
  executeLink(
    "/v1/propositions",
    (response) =>
      uploadImagesMessages(
        response.data.course_id,
        getCurrentElement("successful_proposal")
      )
        .then((message) =>
          setTimeout(() => setupModalAndOpen("success", message), 300)
        )
        .catch((message) =>
          setTimeout(() => setupModalAndOpen("error", message), 300)
        ),
    (error) => {
      if (error.response.status == 409) {
        setTimeout(
          () =>
            setupModalAndOpen("error", getCurrentElement("duplicate_course")),
          300
        );
      } else {
        setTimeout(() => setupModalAndOpen("error"), 300);
      }
    },
    "post",
    course_proposition.toProposition()
  );
};
const closeModal = (alert: boolean) => {
  if (alert) {
    alert_open.value = false;
  } else {
    addition.value = false;
  }
};
const setupModalAndOpen = async (
  window: AvailableModal,
  message?: string,
  approval?: boolean
) => {
  alert_information.inputs = [];
  switch (window) {
    case "confirm":
      alert_information.title = "";
      alert_information.message = getCurrentElement(
        approval == undefined
          ? "proposition_confrimation"
          : approval
          ? "approval_confirmation"
          : "rejection_confirmation"
      );
      alert_information.buttons = [
        {
          text: getCurrentElement("yes"),
          role: "yes",
          handler: approval == undefined ? propose : () => approve(approval),
        },
        getCurrentElement("no"),
      ];
      if (approval == true) {
        alert_information.inputs = [
          {
            type: "checkbox",
            label: getCurrentElement("approve_project_class_too"),
            checked: true,
            handler: (input) => {
              approve_project_class = input.checked ?? true;
            },
          },
        ];
      }
      break;
    case "success":
      alert_information.title = "";
      alert_information.message =
        message ?? getCurrentElement("successful_operation");
      alert_information.buttons = [getCurrentElement("ok")];
      break;
    case "error":
      setAlertError(
        message ?? store.state.event.data?.message ?? getCurrentElement("error")
      );
      break;
  }
  alert_open.value = true;
};
const setAlertError = (message: string | undefined) => {
  alert_information.title = getCurrentElement("error");
  alert_information.message = message ?? getCurrentElement("general_error");
  alert_information.buttons = [getCurrentElement("ok")];
};
const getTitle = (obj: any) =>
  `${language}_title` in obj ? obj[`${language}_title`] : undefined;
const learningContextToString = (learning_context: LearningContext) =>
  learning_context[`${language}_title`];
const studyAddressToString = (study_address: StudyAddress) =>
  study_address[`${language}_title`];
const teacherToString = (teacher: Teacher) =>
  teacher.name + " " + teacher.surname;
const castToTitles = (titles: any) => titles as PropositionTitles;
const castToCharacteristics1 = (characteristics: any) =>
  characteristics as PropositionCharacteristics1;
/*const castToCharacteristics2 = (characteristics: any) =>
  characteristics as PropositionCharacteristics2;*/
const castToDescription = (description: any) =>
  description as PropositionDescription;
const castToExpectedLearningResults = (expected_learning_results: any) =>
  expected_learning_results as PropositionExpectedLearningResults;
const castToCriterions = (criterions: any) =>
  criterions as PropositionCriterions;
const castToActivities = (activities: any) =>
  activities as PropositionActivities;
const castToSpecificInformation = (specific_information: any) =>
  specific_information as PropositionSpecificInformation;
const addToSimpleList = (
  type: SimpleListTypes,
  id?: string | number,
  only_card = false,
  change_support_list = true
) => {
  let actual_id: string | number;
  let reference: SimpleList<Teaching | GrowthArea>;
  let cards_reference: OrderedCardsList<GeneralCardElements>;
  let tmp_index: number;
  let to_add: Teaching | GrowthArea;

  if (type == "teachings") {
    actual_id = id ?? selected_teaching.value;
    reference = teachings;
    cards_reference = teachings_cards;
  } else {
    actual_id = id ?? selected_growth_area.value;
    reference = growth_areas;
    cards_reference = growth_areas_cards;
  }

  const support_list = change_support_list
    ? reference.available
    : reference.selected;

  if (
    actual_id != (type == "teachings" ? "" : 0) &&
    (tmp_index = support_list.findIndex((a) => a.id == actual_id)) != -1
  ) {
    to_add = support_list[tmp_index];
    cards_reference.cards[""].push(to_add.toCard(action.value == "view"));

    if (type == "teachings") {
      if (!only_card) {
        course_proposition.characteristics2.teaching_list.push(
          to_add.id as string
        );
      }
      if (change_support_list) {
        teachings.selected.push(to_add as Teaching);
        teachings.available.splice(tmp_index, 1);
      }
      if (id == undefined) {
        selected_teaching.value = "";
      }
    } else {
      if (!only_card) {
        course_proposition.characteristics2.growth_list.push(
          to_add.id as number
        );
      }
      if (change_support_list) {
        growth_areas.selected.push(to_add as GrowthArea);
        growth_areas.available.splice(tmp_index, 1);
      }
      if (id == undefined) {
        selected_growth_area.value = 0;
      }
    }

    trigger.value++;
  }
};
const addAccess = (
  learning_context_id?: string,
  access_object?: AccessObject,
  only_card = false,
  change_support_list = true
) => {
  const actual_learning_context_id =
    learning_context_id ?? selected_learning_context.value;
  let actual_study_address_id: string;
  let actual_study_year: number;
  let actual_presidium: boolean;
  let actual_main_study_year: boolean;

  let tmp_learning_context_index: number;
  let tmp_study_address_index: number;
  let tmp_study_year_index: number;
  let tmp_access_proposition: AccessProposition;
  let learning_context: LearningContext;
  let study_address: StudyAddress;
  let study_year: { id: number };

  if (access_object != undefined) {
    actual_study_address_id = access_object.study_address;
    actual_study_year = access_object.study_year;
    actual_presidium = access_object.presidium;
    actual_main_study_year = access_object.main_study_year;
  } else {
    actual_study_address_id = selected_study_address.value;
    actual_study_year = selected_study_year.value;
    actual_presidium = presidium.value;
    actual_main_study_year = main_study_year.value;
  }

  const support_context_list_index = change_support_list
    ? "available"
    : study_addresses.available[actual_learning_context_id] != undefined &&
      Object.keys(study_addresses.available[actual_learning_context_id])
        .length > 0
    ? "available"
    : "selected";
  const support_address_list_index = change_support_list
    ? "available"
    : support_context_list_index != "selected" &&
      study_years.available[actual_learning_context_id][
        actual_study_address_id
      ] != undefined &&
      Object.keys(
        study_years.available[actual_learning_context_id][
          actual_study_address_id
        ]
      ).length > 0
    ? "available"
    : "selected";
  const support_year_list_index = change_support_list
    ? "available"
    : "selected";

  if (
    actual_learning_context_id != "" &&
    (tmp_learning_context_index = learning_contexts[
      support_context_list_index
    ].findIndex((a) => a.id == actual_learning_context_id)) != -1 &&
    actual_study_address_id != "" &&
    (tmp_study_address_index = study_addresses[support_address_list_index][
      actual_learning_context_id
    ].findIndex((a) => a.id == actual_study_address_id)) != -1 &&
    actual_study_year != 0 &&
    (tmp_study_year_index = study_years[support_year_list_index][
      actual_learning_context_id
    ][actual_study_address_id].findIndex((a) => a.id == actual_study_year)) !=
      -1
  ) {
    learning_context =
      learning_contexts[support_context_list_index][tmp_learning_context_index];
    study_address =
      study_addresses[support_address_list_index][learning_context.id][
        tmp_study_address_index
      ];
    study_year =
      study_years[support_year_list_index][learning_context.id][
        study_address.id
      ][tmp_study_year_index];

    tmp_access_proposition = new AccessProposition(
      study_year.id,
      study_address,
      actual_presidium,
      actual_main_study_year
    );

    if (!only_card) {
      if (course_proposition.access_object[learning_context.id] == undefined) {
        course_proposition.access_object[learning_context.id] = [];
      }
      course_proposition.access_object[learning_context.id].push(
        tmp_access_proposition.toAccessObj()
      );
    }

    if (access_propositions_cards.cards[learning_context.id] == undefined) {
      access_propositions_cards.order.push({
        key: learning_context.id,
        title: getCustomMessage(
          "title",
          learning_context[`${language}_title`],
          "title"
        ),
      });
      access_propositions_cards.order.sort((a, b) =>
        a.key == b.key ? 0 : a.key > b.key ? 1 : -1
      );
      access_propositions_cards.cards[learning_context.id] = [];
    }
    access_propositions_cards.cards[learning_context.id].push(
      tmp_access_proposition.toCard(
        actual_learning_context_id,
        action.value == "view"
      )
    );

    if (change_support_list) {
      if (study_years.selected[learning_context.id] == undefined) {
        study_years.selected[learning_context.id] = {};
      }
      if (
        study_years.selected[learning_context.id][study_address.id] == undefined
      ) {
        study_years.selected[learning_context.id][study_address.id] = [];
      }
      study_years.selected[learning_context.id][study_address.id].push(
        study_year
      );
      study_years.available[learning_context.id][study_address.id].splice(
        tmp_study_year_index,
        1
      );
      if (access_object == undefined) {
        selected_study_year.value = 0;
      }

      if (
        study_years.available[learning_context.id][study_address.id].length == 0
      ) {
        if (study_addresses.selected[learning_context.id] == undefined) {
          study_addresses.selected[learning_context.id] = [];
        }
        study_addresses.selected[learning_context.id].push(study_address);
        study_addresses.available[learning_context.id].splice(
          tmp_study_address_index,
          1
        );
        if (access_object == undefined) {
          selected_study_address.value = "";
        }
      }
      if (study_addresses.available[learning_context.id].length == 0) {
        learning_contexts.selected.push(learning_context);
        learning_contexts.available.splice(tmp_learning_context_index, 1);
        if (learning_context == undefined) {
          selected_learning_context.value = "";
        }
      }

      if (access_object == undefined) {
        presidium.value = false;
        main_study_year.value = false;
      }
    }
  }
  trigger.value++;
};
const addTeacher = (
  proposition_teacher?: PropositionTeacher,
  only_card = false,
  change_support_list = true
) => {
  let actual_teacher_id: number;
  let actual_main_teacher: boolean;
  let tmp_teacher_index: number;
  let teacher: Teacher;
  let teacher_proposition: TeacherProposition;

  if (proposition_teacher != undefined) {
    actual_teacher_id = proposition_teacher.teacher_id;
    actual_main_teacher = proposition_teacher.main;
  } else {
    actual_teacher_id = selected_teacher.value;
    actual_main_teacher = main_teacher.value;
  }

  const support_list = change_support_list
    ? teachers.available
    : teachers.selected;
  if (
    actual_teacher_id != 0 &&
    (tmp_teacher_index = support_list.findIndex(
      (a) => a.id == actual_teacher_id
    )) != -1 &&
    (proposition_teacher != undefined
      ? proposition_teacher.sections.length > 0
      : sections.find((a) => a))
  ) {
    teacher = support_list[tmp_teacher_index];
    teacher_proposition = new TeacherProposition(
      teacher,
      actual_main_teacher,
      sections
    );

    if (!only_card) {
      course_proposition.specific_information.teacher_list.push(
        teacher_proposition.toTeacherObj()
      );
    }

    teachers_cards.cards[""].push(
      teacher_proposition.toCard(action.value == "view")
    );

    if (change_support_list) {
      teachers.selected.push(teacher);
      teachers.available.splice(tmp_teacher_index, 1);
    }
    if (proposition_teacher == undefined) {
      selected_teacher.value = 0;
      main_teacher.value = false;
      for (const i in sections) {
        sections[i] = false;
      }
      sections[0] = true;
    }
  }
  trigger.value++;
};
const addElement = (type: CardsListTypes) => {
  // TODO (9): trovare pezzi in comune negli switch per semplificare la funzione e la successiva
  switch (type) {
    case "teachings":
      addToSimpleList("teachings");
      break;
    case "growth_areas":
      addToSimpleList("growth_areas");
      break;
    case "access":
      addAccess();
      break;
    case "teachers":
      addTeacher();
      break;
  }
};
const removeSimpleElement = (type: SimpleListTypes) => {
  let reference: SimpleList<Teaching | GrowthArea>;
  let cards_reference: OrderedCardsList<GeneralCardElements>;

  if (type == "teachings") {
    reference = teachings;
    cards_reference = teachings_cards;
  } else {
    reference = growth_areas;
    cards_reference = growth_areas_cards;
  }

  const id: string | number = store.state.event.data.id;
  const tmp_index: number = reference.selected.findIndex((a) => a.id == id);

  if (type == "teachings") {
    course_proposition.characteristics2.teaching_list.splice(
      course_proposition.characteristics2.teaching_list.indexOf(id as string),
      1
    );
  } else {
    course_proposition.characteristics2.growth_list.splice(
      course_proposition.characteristics2.growth_list.indexOf(id as number),
      1
    );
  }

  cards_reference.cards[""].splice(
    cards_reference.cards[""].findIndex((a) => a.id == id),
    1
  );

  reference.available.push(reference.selected[tmp_index]);
  reference.available.sort((a, b) => (a.id == b.id ? 0 : a.id > b.id ? 1 : -1));
  reference.selected.splice(tmp_index, 1);
};
const removeElement = (type: CardsListTypes) => {
  let learning_context_id: string;
  let study_address_id: string;
  let study_year: number;
  let access_id: string;
  let tmp_learning_context_index: number;
  let tmp_study_address_index: number;
  let tmp_study_year_index: number;

  let teacher_id: number;
  let tmp_teacher_index: number;

  switch (type) {
    case "teachings":
      removeSimpleElement("teachings");
      break;
    case "growth_areas":
      removeSimpleElement("growth_areas");
      break;
    case "access":
      learning_context_id = store.state.event.data.learning_context_id;
      study_address_id = store.state.event.data.study_address_id;
      study_year = store.state.event.data.study_year;
      access_id =
        learning_context_id + "_" + study_address_id + "_" + study_year;

      tmp_learning_context_index = learning_contexts.selected.findIndex(
        (a) => a.id == learning_context_id
      );
      tmp_study_address_index =
        study_addresses.selected[learning_context_id] != undefined
          ? study_addresses.selected[learning_context_id].findIndex(
              (a) => a.id == study_address_id
            )
          : -1;
      tmp_study_year_index = study_years.selected[learning_context_id][
        study_address_id
      ].findIndex((a) => a.id == study_year);

      course_proposition.access_object[learning_context_id].splice(
        course_proposition.access_object[learning_context_id].findIndex(
          (a) =>
            a.study_address == study_address_id && a.study_year == study_year
        ),
        1
      );

      access_propositions_cards.cards[learning_context_id].splice(
        access_propositions_cards.cards[learning_context_id].findIndex(
          (a) => a.id == access_id
        ),
        1
      );
      if (access_propositions_cards.cards[learning_context_id].length == 0) {
        access_propositions_cards.order.splice(
          access_propositions_cards.order.findIndex(
            (a) => a.key == learning_context_id
          ),
          1
        );
        delete access_propositions_cards.cards[learning_context_id];
      }

      study_years.available[learning_context_id][study_address_id].push(
        study_years.selected[learning_context_id][study_address_id][
          tmp_study_year_index
        ]
      );
      study_years.available[learning_context_id][study_address_id].sort(
        (a, b) => (a.id == b.id ? 0 : a.id > b.id ? 1 : -1)
      );
      study_years.selected[learning_context_id][study_address_id].splice(
        tmp_study_year_index,
        1
      );
      if (
        tmp_study_address_index != -1 &&
        study_years.available[learning_context_id][study_address_id].length > 0
      ) {
        study_addresses.selected[learning_context_id].push(
          study_addresses.available[learning_context_id][0]
        );
        study_addresses.available[learning_context_id].sort((a, b) =>
          a.id == b.id ? 0 : a.id > b.id ? 1 : -1
        );
        study_addresses.available[learning_context_id].splice(0, 1);
      }
      if (
        tmp_learning_context_index != -1 &&
        study_addresses.available[learning_context_id].length > 0
      ) {
        learning_contexts.selected.push(learning_contexts.available[0]);
        learning_contexts.available.sort((a, b) =>
          a.id == b.id ? 0 : a.id > b.id ? 1 : -1
        );
        learning_contexts.available.splice(0, 1);
      }
      break;
    case "teachers":
      teacher_id = store.state.event.data.id;
      tmp_teacher_index = teachers.selected.findIndex(
        (a) => a.id == teacher_id
      );

      course_proposition.specific_information.teacher_list.splice(
        course_proposition.specific_information.teacher_list.findIndex(
          (a) => a.teacher_id == teacher_id
        ),
        1
      );
      teachers_cards.cards[""].splice(
        teachers_cards.cards[""].findIndex((a) => a.id == "" + teacher_id),
        1
      );

      teachers.available.push(teachers.selected[tmp_teacher_index]);
      teachers.available.sort((a, b) =>
        a.id == b.id ? 0 : a.id > b.id ? 1 : -1
      );
      teachers.selected.splice(tmp_teacher_index, 1);
      break;
  }
  trigger.value++;
};
const edit_course_proposition = async (course_id?: number) => {
  let course: Course;
  let learning_area: LearningArea;
  if (course_id != undefined && !Number.isNaN(course_id)) {
    course = await Course.newCourse(
      "/v1/courses/" + course_id + "?admin_info=true"
    );
    approved.course = course.certifying_admin?.id != null;
    learning_area = await executeLink("/v1/learning_areas", (response) => {
      const tmp_area = response.data.data.find(
        (a: LearningArea) =>
          a.italian_title == course.italian_learning_area &&
          a.english_title == course.english_learning_area
      ); //<!-- TODO (8): aspettare che Pietro metta id
      return tmp_area != undefined
        ? tmp_area
        : {
            id: -1,
            italian_title: "",
            english_title: "",
          };
    });
    images_list.value = course.images_list;
    old_images_names = course.images_list.map((a) => a.name);
    if (tmp_session_id != -1) {
      project_class = await executeLink(
        "/v1/project_classes/" + course_id + "/" + tmp_session_id,
        (response) => new AdminProjectClass(response.data.data)
      ); //<!-- TODO (4): dire a Pietro di mettere num_section sia lì che in quella generale
      approved.project_class = project_class.admin_id != undefined;
      tmp_teachers = await executeLink(
        "/v1/project_classes/" + course_id + "/" + tmp_session_id + "/teachers",
        (response) => {
          const teachers_summary: {
            [id: number]: PropositionTeacher;
          } = {};
          let tmp_id: number;

          for (const teacher_section of response.data.data) {
            tmp_id = teacher_section.teacher_ref.data.id;

            if (teachers_summary[tmp_id] == undefined) {
              teachers_summary[tmp_id] = {
                teacher_id: tmp_id,
                main: teacher_section.main_teacher === 1,
                sections: [],
              };
            }
            teachers_summary[tmp_id].sections.push(teacher_section.section);
          }

          return Object.values(teachers_summary);
        },
        () => []
      );
    }
    course_proposition = reactive(
      new ModelProposition({
        course_id: course_id,
        italian_title: course.italian_title,
        english_title: course.english_title,
        up_hours: course.up_hours,
        credits: course.credits,
        area_id: learning_area.id,
        growth_list: course.growth_list.map((a) => a.id),
        session_id: tmp_session_id,
        project_class_code: project_class?.project_class_code ?? "",
        class_group: project_class?.group ?? -1,
        num_section: 1,
        min_students: course.min_students,
        max_students: course.max_students,
        teaching_list: course.teaching_list.map((a) => a.id),
        italian_descr: course.italian_description,
        english_descr: course.english_description,
        italian_exp_l: course.italian_expected_learning_results,
        english_exp_l: course.english_expected_learning_results,
        italian_cri: course.italian_criterions,
        english_cri: course.english_criterions,
        italian_act: course.italian_activities,
        english_act: course.english_activities,
        access_object: course.access_object,
        images_list: images_list.value.filter((a) => a instanceof File),
        teacher_list: tmp_teachers,
      })
    );
    selected_session.value = tmp_session_id;
    fillCardsLists({});
  } else {
    course_proposition = reactive(new ModelProposition());
  }
  trigger.value++;
};
const fillCardsLists = (lists_info: {
  [key in keyof string as PropositionListsKeys]?: {
    //<!-- TODO (6): guardare se si può mettere CardsListTypes
    clear?: {
      cards?: boolean;
      support_list?: boolean;
    };
    only_card?: boolean;
    change_support_list?: boolean;
  };
}) => {
  if (lists_info["teaching_list"]?.clear != undefined) {
    if (lists_info["teaching_list"]?.clear.cards == true) {
      teachings_cards.order = [];
      teachings_cards.cards = {
        "": [],
      };
    }
    if (lists_info["teaching_list"]?.clear.support_list == true) {
      teachings.available = [];
      teachings.selected = [];
    }
  }
  for (const teaching of course_proposition.characteristics2.teaching_list) {
    addToSimpleList(
      "teachings",
      teaching,
      lists_info["teaching_list"]?.only_card ?? true,
      lists_info["teaching_list"]?.change_support_list
    );
  }
  if (lists_info["growth_list"]?.clear != undefined) {
    if (lists_info["growth_list"]?.clear.cards == true) {
      growth_areas_cards.order = [];
      growth_areas_cards.cards = {
        "": [],
      };
    }
    if (lists_info["growth_list"]?.clear.support_list == true) {
      growth_areas.available = [];
      growth_areas.selected = [];
    }
  }
  for (const growth_area of course_proposition.characteristics2.growth_list) {
    addToSimpleList(
      "growth_areas",
      growth_area,
      lists_info["growth_list"]?.only_card ?? true,
      lists_info["growth_list"]?.change_support_list
    );
  }
  if (lists_info["access_object"]?.clear != undefined) {
    if (lists_info["access_object"]?.clear.cards == true) {
      access_propositions_cards.order = [];
      access_propositions_cards.cards = {};
    }
    if (lists_info["access_object"]?.clear.support_list == true) {
      course_proposition.access_object = {};
      learning_contexts.available = [];
      learning_contexts.selected = [];
      study_addresses.available = {};
      study_addresses.selected = {};
      study_years.available = {};
      study_years.selected = {};
    }
  }
  for (const learning_context_id in course_proposition.access_object) {
    //<!-- TODO (9): attenzione, non funziona
    for (const access_object of course_proposition.access_object[
      learning_context_id
    ]) {
      addAccess(
        learning_context_id,
        access_object,
        lists_info["access_object"]?.only_card ?? true,
        lists_info["access_object"]?.change_support_list
      );
    }
  }
  if (course_proposition.specific_information.session_id != undefined) {
    if (lists_info["teacher_list"]?.clear != undefined) {
      if (lists_info["teacher_list"]?.clear.cards == true) {
        teachers_cards.order = [];
        teachers_cards.cards = {
          "": [],
        };
      }
      if (lists_info["teacher_list"]?.clear.support_list == true) {
        teachers.available = [];
        teachers.selected = [];
      }
    }
    selected_session.value = course_proposition.specific_information.session_id;
    for (const teacher of course_proposition.specific_information
      .teacher_list) {
      addTeacher(
        teacher,
        lists_info["teacher_list"]?.only_card ?? true,
        lists_info["teacher_list"]?.change_support_list
      );
    }
  }
};
const changeModality = (new_action: PropositionActions) => {
  const tmp_lists_info = {
    clear: {
      cards: true,
    },
    change_support_list: false,
  };
  const lists_info = {
    teaching_list: !approved.course ? tmp_lists_info : undefined,
    growth_list: !approved.course ? tmp_lists_info : undefined,
    access_object: !approved.course ? tmp_lists_info : undefined,
    teacher_list: tmp_lists_info,
  };

  //let changes_error = false;

  if (action.value == "edit" && new_action == "view") {
    if (checkAndWarn()) {
      executeLink(
        "/v1/courses/" + course_proposition.course_id,
        async () => {
          const remaining_old_images: ImageDescriptor[] =
            images_list.value.filter(
              (a) => !(a instanceof File)
            ) as ImageDescriptor[];

          /*let message = "";

          if (course_proposition.images_list.length > 0) {f
            message = await uploadImagesMessages(
              course_proposition.course_id,
              ""
            ).then(a => a).catch(a => a);
            if (message != "") {
              images_list.value = images_list.value.filter(
                (a) => !(a instanceof File)
              );
            }
          }*/
          if (
            //message == "" &&
            old_images_names.length > 0 &&
            remaining_old_images.length != old_images_names.length
          ) {
            if (remaining_old_images.length == 0) {
              executeLink(
                "/v1/images/course/" + course_proposition.course_id,
                undefined,
                () => getCurrentElement("images_upload_error"),
                "delete"
              );
            } else {
              for (const image_name of old_images_names.filter(
                (a) => remaining_old_images.findIndex((b) => a == b.name) == -1
              )) {
                executeLink(
                  "/v1/images/course/" +
                    course_proposition.course_id +
                    "?name=" +
                    image_name,
                  undefined,
                  () => getCurrentElement("images_upload_error"),
                  "delete"
                );
              }
            }
          } /*else if (message != "") {
            setupModalAndOpen("error", message);
          }*/
        },
        () => {
          //changes_error = true; //<!-- TODO (6): fare "esci senza salvare"
          setupModalAndOpen("error", getCurrentElement("changes_not_made"));
        },
        "put",
        course_proposition.toProposition()
      );
      action.value = new_action;
      fillCardsLists(lists_info);
    }
  } else if (action.value == "view" && new_action == "edit") {
    action.value = new_action;
    fillCardsLists(lists_info);
  }
  trigger.value++;
};
const approve = (outcome = true) => {
  if (course_proposition.specific_information.session_id != -1) {
    executeLink(
      "/v1/propositions/approval?course_id=" +
        course_proposition.course_id +
        "&session_id=" +
        course_proposition.specific_information.session_id +
        "&approved=" +
        outcome +
        (outcome ? "&proj_class=" + approve_project_class : ""),
      () => {
        approve_project_class = true;
        setTimeout(() => {
          setupModalAndOpen(
            "success",
            getCurrentElement(
              "successful_" + (outcome ? "confirmation" : "rejection")
            )
          );
          $router.push({ name: "propositions_history" });
        }, 300);
      },
      () => {
        approve_project_class = true;
        setTimeout(() => {
          setupModalAndOpen("error", getCurrentElement("general_error"));
        }, 300);
      },
      "put"
    );
  } else {
    approve_project_class = true;
    setTimeout(() => {
      setupModalAndOpen("error", getCurrentElement("general_error"));
    }, 300);
  }
};
const allApproed = () => approved.course && approved.project_class;
const moveImage = (event: CustomEvent) => {
  event.detail.complete(images_list.value);
};
const removeImage = () => {
  const image_index = images_list.value.findIndex(
    (a) => a.name == store.state.event.data.name
  );

  if (image_index != -1) {
    images_list.value.splice(image_index, 1);
    carousel_trigger.value++;
  }
};
const uploadImagesMessages = async (
  refer_course_id: number | undefined,
  successful_message: string
) => {
  let status = undefined;

  if (course_proposition.images_list.length > 0) {
    status = await uploadMultipleImages(
      "/v1/images/course/" + refer_course_id,
      course_proposition.images_list
    )
      .then((a) => a)
      .catch((a) => a);
  }

  return new Promise<string>((resolve, reject) =>
    status == undefined || status == 201
      ? resolve(successful_message)
      : reject(
          (successful_message != "" ? successful_message + ". " : "") +
            (status == 400
              ? getCurrentElement("images_upload_error")
              : status == 401
              ? getCurrentElement("unauthorized_image_uploading")
              : getCurrentElement("error"))
        )
  );
};
const getReorderLabel = (index: number, name: string, disabled: boolean) => {
  const to_ret: CustomElement = {
    id: "image_" + index,
    type: "string",
    content: name,
    classes: {
      item: {
        w_100: true,
      },
    },
  };

  if (!disabled) {
    Object.assign(to_ret, {
      type: "string_icon",
      linkType: "event",
      content: {
        text: name,
        icon: getIcon("close"),
        event: "remove",
        data: {
          name: name,
        },
      },
    });
  }

  return to_ret;
};
const castAsArray = (e: any) => e as Array<any>;
/*const parameters_remaining = computed(
  () => course_proposition.remaining.length == 0
);*/

const store = useStore();
const user = User.getLoggedUser() as User;
const language = getCurrentLanguage();
const languages = getAviableLanguages();
const $route = useRoute();
const $router = useRouter();
const alert_information: AlertInformation = store.state.alert_information;

const trigger = ref(0);
const carousel_trigger = ref(0);
const alert_open = ref(false);
const pages = ModelProposition.getProps("pages");
const current_page_index = ref(0);
const button_css = Object.assign(
  JSON.parse(JSON.stringify(store.state.button_css)),
  {
    classes: {
      button: {
        radius: true,
        "ion-margin-start": {
          general: true,
          sm: false,
        },
      },
    },
  }
);
const buttons: CustomElement[] = [
  {
    id: "back",
    type: "icon",
    linkType: "event",
    content: {
      event: "back",
      icon: getIcon("arrow_back"),
    },
  },
  {
    id: "next",
    type: "icon",
    linkType: "event",
    content: {
      event: "next",
      icon: getIcon("arrow_forward"),
    },
  },
  {
    id: "teacher_info",
    type: "icon",
    linkType: "event",
    content: {
      event: "teacher_info",
      icon: getIcon("information_circle"),
    },
  },
  {
    id: "history",
    type: "string_icon",
    linkType: "request",
    content: {
      url: "/propositions_history",
      method: "get",
      icon: getIcon("archive"),
      text: getCurrentElement("history"),
      whole_link: true,
    },
    ...button_css,
  },
  {
    id: "approve",
    type: "string_icon",
    linkType: "event",
    content: {
      event: "approve",
      icon: getIcon("checkmark"),
      text: getCurrentElement("approve"),
      whole_link: true,
    },
    ...button_css,
  },
  {
    id: "reject",
    type: "string_icon",
    linkType: "event",
    content: {
      event: "reject",
      icon: getIcon("close"),
      text: getCurrentElement("reject"),
      whole_link: true,
    },
    ...button_css,
  },
  {
    id: "edit",
    type: "string_icon",
    linkType: "event",
    content: {
      event: "edit",
      icon: getIcon("pencil"),
      text: getCurrentElement("edit"),
      whole_link: true,
    },
    ...button_css,
  },
  {
    id: "view",
    type: "string_icon",
    linkType: "event",
    content: {
      event: "view",
      icon: getIcon("eye"),
      text: getCurrentElement("view"),
      whole_link: true,
    },
    ...button_css,
  },
];
const selected_session = ref(-1);
const addition = ref(false);
const presidium = ref(false);
const main_study_year = ref(false);
const selected_teaching = ref("");
const selected_growth_area = ref(0);
const tmp_set: Set<number> = new Set();
const selected_learning_context = ref("");
const selected_study_address = ref("");
const selected_study_year = ref(0);
const teachings_cards: OrderedCardsList<GeneralCardElements> = {
  order: [],
  cards: {
    "": [],
  },
};
const teachings: SimpleList<Teaching> = {
  available: [],
  selected: [],
};
const growth_areas_cards: OrderedCardsList<GeneralCardElements> = {
  order: [],
  cards: {
    "": [],
  },
};
const growth_areas: SimpleList<GrowthArea> = {
  available: [],
  selected: [],
};
const access_propositions_cards: OrderedCardsList<GeneralCardElements> = {
  order: [],
  cards: {},
};
const learning_contexts: {
  available: LearningContext[];
  selected: LearningContext[];
} = {
  available: [],
  selected: [],
};
const study_addresses: {
  available: {
    [key: string]: StudyAddress[];
  };
  selected: {
    [key: string]: StudyAddress[];
  };
} = {
  available: {},
  selected: {},
};
const study_years: {
  //<!-- TODO (5): mettere elenco check e usare card per study_address con X per ogni classe
  available: {
    [key: string]: {
      [key: string]: { id: number }[];
    };
  };
  selected: {
    [key: string]: {
      [key: string]: { id: number }[];
    };
  };
} = {
  available: {},
  selected: {},
};
const selected_teacher = ref(0);
const teachers: {
  available: Teacher[];
  selected: Teacher[];
} = {
  available: [],
  selected: [],
};
const num_section: Ref<string> = ref("1"); //<!-- TODO (10): bug di ion-input che da stringa anche con type="number"
const main_teacher = ref(false);
const teachers_cards: OrderedCardsList<GeneralCardElements> = {
  order: [],
  cards: {
    "": [],
  },
};
const action: Ref<PropositionActions> = ref(
  $route.query.view != undefined ? "view" : "propose"
);
const tmp_project_class_id =
  $route.query[action.value] != undefined
    ? ($route.query[action.value] as string).split("_")
    : [];
const selected_model: Ref<number | undefined> = ref(
  tmp_project_class_id.length > 0
    ? parseInt(tmp_project_class_id[0])
    : undefined
);
const tmp_session_id =
  tmp_project_class_id.length > 1 ? parseInt(tmp_project_class_id[1]) : -1;
const approved: {
  course: boolean;
  project_class: boolean;
} = {
  course: false,
  project_class: false,
};
const sections_use: boolean = store.state.sections_use;
const images_list: Ref<(ImageDescriptor | File)[]> = ref([]);
const progress_infos: Ref<
  {
    percentage: number;
  }[]
> = ref([]);
/*const correspondences: {
  [key in keyof string as ListTypes]: {
    [key: string]: string
  }
} = {
  teachings: {
    list
  },
  access: {

  },
  teachers: {

  }
}*/

let course_proposition = reactive(new ModelProposition());
let models: CourseModel[] = [];
let learning_areas: LearningArea[] = [];
let learning_sessions: LearningSession[] = [];
let groups: { id: number }[] = [];
let sections: boolean[] = reactive([true]);
let project_class: AdminProjectClass;
let tmp_teachers: PropositionTeacher[] = [];
let approve_project_class = true;
let old_images_names: string[] = [];

/*switch (pages[current_page_index.value]) { //<!-- TODO (6): caricare una volta i vari contenuti
  case "teaching_list":
    
    break;
  case "access_object":
  case "teacher_list":
    
    break;
  default:
    break;
}*/
models = (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
  "/v1/propositions?recent_models=true", //<!-- TODO (5): fare rework recent_models (mettere filtro su tutti i corsi)
  (response) =>
    response.data.data.map((a: CourseModelProps) => new CourseModel(a)),
  () => []
))),
  __temp = await __temp,
  __restore(),
  __temp
);
learning_areas = (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
  "/v1/learning_areas?all_data=true",
  (response) => response.data.data,
  () => []
))),
  __temp = await __temp,
  __restore(),
  __temp
);
growth_areas.available = (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
  "/v1/growth_areas",
  (response) =>
    response.data.data.map((a: GrowthAreaProps) => new GrowthArea(a)),
  () => []
))),
  __temp = await __temp,
  __restore(),
  __temp
);
learning_sessions = (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
  "/v1/learning_sessions?" +
    (action.value != "view" ? "future_session=true" : ""), //<!-- TODO (6): aggiungere course_id quando Pietro finisce
  (response) => {
    const tmp_learning_sessions: LearningSession[] = [];

    let tmp_session: LearningSession;

    for (const session of response.data.data) {
      tmp_session = new LearningSession(session);
      tmp_set.add(tmp_session.school_year);
      tmp_learning_sessions.push(tmp_session);
    }

    return tmp_learning_sessions;
  },
  () => []
))),
  __temp = await __temp,
  __restore(),
  __temp
);
teachings.available = (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
  "/v1/teachings?all_data=true",
  (response) => response.data.data.map((a: TeachingProps) => new Teaching(a)),
  () => []
))),
  __temp = await __temp,
  __restore(),
  __temp
);

learning_contexts.available = (
  ([__temp,__restore] = _withAsyncContext(() => getLearningContexts(user))),
  __temp = await __temp,
  __restore(),
  __temp
);
;(
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
  "/v1/study_addresses",
  (response) => {
    for (const context of learning_contexts.available) {
      study_addresses.available[context.id] = [];
      study_years.available[context.id] = {};
      for (const address of response.data.data) {
        study_addresses.available[context.id].push(address);
        study_years.available[context.id][address.id] = Array.from(
          { length: address.max_classes },
          (value, index) => {
            return {
              id: index + 1,
            };
          }
        );
      }
    }
  },
  () => []
))),
  await __temp,
  __restore()
);
teachers.available = (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
  "/v1/teachers",
  (response) => response.data.data.map((a: TeacherProps) => new Teacher(a)),
  () => []
))),
  __temp = await __temp,
  __restore(),
  __temp
);

watch(selected_session, (new_session) => {
  const tmp_learning_session = learning_sessions.find(
    (a) => a.id == new_session
  );

  course_proposition.specific_information.session_id = new_session;
  groups = Array.from(
    {
      length:
        tmp_learning_session != undefined ? tmp_learning_session.num_groups : 0,
    },
    (_, i) => {
      return {
        id: i + 1,
      };
    }
  );
  trigger.value++;
});
watch(selected_learning_context, (new_learning_context) => {
  if (
    new_learning_context != undefined &&
    study_addresses.available[new_learning_context] != undefined &&
    study_addresses.available[new_learning_context].findIndex(
      (a) => a.id == selected_study_address.value
    ) == -1
  ) {
    selected_study_address.value = "";
  }
  trigger.value++;
});
watch(selected_study_address, (new_study_address) => {
  let tmp_study_address;

  if (
    new_study_address != "" &&
    (tmp_study_address = study_addresses.available[
      selected_learning_context.value
    ].find((a) => a.id == new_study_address)) != undefined &&
    selected_study_year.value > tmp_study_address.max_classes
  ) {
    selected_study_year.value = 0;
  }
  trigger.value++;
});
watch(num_section, (n, o) => {
  const actual_n = n != "" ? parseInt(n) : 0;

  course_proposition.specific_information.num_section = actual_n;
  if (actual_n > 0) {
    course_proposition.specific_information.num_section = actual_n;
    if (sections.length > actual_n) {
      sections.splice(actual_n);
    } else if (sections.length < actual_n) {
      sections = reactive(
        sections.concat(new Array(actual_n - sections.length).fill(false))
      );
      if (sections.length > 0) {
        sections[0] = true;
      }
    }
  } else {
    num_section.value = o;
  }
});
if (selected_model.value != undefined) {
  edit_course_proposition(selected_model.value);
}
watch(selected_model, () => {
  if (selected_model.value != undefined) {
    edit_course_proposition(selected_model.value);
  }
  trigger.value++;
});
watch(selected_teaching, () => {
  addElement("teachings");
});
watch(selected_growth_area, () => {
  addElement("growth_areas");
});
if (!sections_use) {
  watch(selected_teacher, (n) => {
    if (n != 0) {
      addElement("teachers");
    }
  });
}
watch(
  () => images_list.value,
  (value) => {
    course_proposition.images_list = value.filter((a) => a instanceof File);
  }
);

return (_ctx: any,_cache: any) => {
  const _component_ionic_element = _resolveComponent("ionic-element")!
  const _component_custom_select = _resolveComponent("custom-select")!
  const _component_editor_wrapper = _resolveComponent("editor-wrapper")!
  const _component_list_card = _resolveComponent("list-card")!
  const _component_image_carousel = _resolveComponent("image-carousel")!
  const _component_image_uploader = _resolveComponent("image-uploader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IonAlert), {
      "is-open": alert_open.value,
      header: _unref(alert_information).title,
      message: _unref(alert_information).message,
      buttons: _unref(alert_information).buttons,
      onDidDismiss: _cache[0] || (_cache[0] = ($event: any) => (closeModal(true))),
      inputs: _unref(alert_information).inputs
    }, null, 8, ["is-open", "header", "message", "buttons", "inputs"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ionic_element, {
        element: buttons[3],
        onExecute_link: _cache[1] || (_cache[1] = ($event: any) => (_unref($router).push(_unref(store).state.request.url)))
      }, null, 8, ["element"]),
      (_unref(user).type == 'admin' && !allApproed())
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (action.value == 'view')
              ? (_openBlock(), _createBlock(_component_ionic_element, {
                  key: 0,
                  element: buttons[4],
                  onSignal_event: _cache[2] || (_cache[2] = ($event: any) => (setupModalAndOpen('confirm', undefined, true)))
                }, null, 8, ["element"]))
              : _createCommentVNode("", true),
            (action.value == 'view')
              ? (_openBlock(), _createBlock(_component_ionic_element, {
                  key: 1,
                  element: buttons[5],
                  onSignal_event: _cache[3] || (_cache[3] = ($event: any) => (setupModalAndOpen('confirm', undefined, false)))
                }, null, 8, ["element"]))
              : _createCommentVNode("", true),
            _createVNode(_component_ionic_element, {
              element: action.value == 'view' ? buttons[6] : buttons[7],
              onSignal_event: _cache[4] || (_cache[4] = ($event: any) => (changeModality(action.value == 'view' ? 'edit' : 'view')))
            }, null, 8, ["element"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(), _createBlock(_component_custom_select, {
      key: trigger.value,
      selected_option: selected_model.value,
      "onUpdate:selected_option": _cache[5] || (_cache[5] = ($event: any) => ((selected_model).value = $event)),
      list: _unref(models),
      label: _unref(getCurrentElement)('reference_model') + ':',
      aria_label: _unref(getCurrentElement)('reference_model'),
      placeholder: _unref(getCurrentElement)('possible_models'),
      getCompleteName: modelToString,
      disabled: action.value != 'propose'
    }, null, 8, ["selected_option", "list", "label", "aria_label", "placeholder", "disabled"])),
    (_openBlock(), _createBlock(_unref(IonCard), { key: trigger.value }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonCardHeader), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCardTitle), {
              class: "ion-text-center",
              color: "white"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getCurrentElement)(
            _unref(ModelProposition).getTitles()[_unref(pages)[current_page_index.value]]
          )), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(IonCardContent), { style: {"overflow-y":"auto"} }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonGrid), null, {
              default: _withCtx(() => [
                (
              _unref(pages)[current_page_index.value] == 'title' ||
              _unref(ModelProposition).getProps('editor').findIndex(
                (a) => a == _unref(pages)[current_page_index.value]
              ) != -1
            )
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(languages), (language) => {
                      return (_openBlock(), _createBlock(_unref(IonRow), { key: language }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonCol), null, {
                            default: _withCtx(() => [
                              (_unref(pages)[current_page_index.value] == 'title')
                                ? (_openBlock(), _createBlock(_unref(IonInput), {
                                    key: 0,
                                    type: "text",
                                    modelValue: 
                    castToTitles(_unref(course_proposition)[_unref(pages)[current_page_index.value]])[
                      `${language}_title`
                    ]
                  ,
                                    "onUpdate:modelValue": ($event: any) => ((
                    castToTitles(_unref(course_proposition)[_unref(pages)[current_page_index.value]])[
                      `${language}_title`
                    ]
                  ) = $event),
                                    label: _unref(getCurrentElement)(language),
                                    "aria-label": _unref(getCurrentElement)(language),
                                    fill: "outline",
                                    class: "ion-margin-vertical",
                                    readonly: 
                    action.value == 'view' ||
                    (action.value == 'edit' && language == 'italian') ||
                    (approved.course &&
                      _unref(ModelProposition).getPropositionProps('optional').indexOf(
                        `${language}_title`
                      ) == -1)
                  
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "aria-label", "readonly"]))
                                : (_unref(pages)[current_page_index.value] == 'description')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                      _createElementVNode("b", null, [
                                        _createVNode(_component_ionic_element, {
                                          element: 
                        _unref(getCustomMessage)(
                          `${language}_descr`,
                          _unref(getCurrentElement)(language)
                        )
                      
                                        }, null, 8, ["element"])
                                      ]),
                                      _createVNode(_component_editor_wrapper, {
                                        value: 
                      castToDescription(
                        _unref(course_proposition)[_unref(pages)[current_page_index.value]]
                      )[`${language}_descr`]
                    ,
                                        "onUpdate:value": ($event: any) => ((
                      castToDescription(
                        _unref(course_proposition)[_unref(pages)[current_page_index.value]]
                      )[`${language}_descr`]
                    ) = $event),
                                        disabled: 
                      action.value == 'view' ||
                      (approved.course &&
                        _unref(ModelProposition).getPropositionProps(
                          'optional'
                        ).indexOf(`${language}_descr`) == -1)
                    ,
                                        options: 
                      action.value == 'view' ||
                      (approved.course &&
                        _unref(ModelProposition).getPropositionProps(
                          'optional'
                        ).indexOf(`${language}_descr`) == -1)
                        ? {
                            modules: {
                              toolbar: false,
                            },
                            placeholder: false,
                          }
                        : undefined
                    
                                      }, null, 8, ["value", "onUpdate:value", "disabled", "options"])
                                    ]))
                                  : (
                    _unref(pages)[current_page_index.value] == 'expected_learning_results'
                  )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        _createElementVNode("b", null, [
                                          _createVNode(_component_ionic_element, {
                                            element: 
                        _unref(getCustomMessage)(
                          `${language}_exp_l`,
                          _unref(getCurrentElement)(language)
                        )
                      
                                          }, null, 8, ["element"])
                                        ]),
                                        _createVNode(_component_editor_wrapper, {
                                          value: 
                      castToExpectedLearningResults(
                        _unref(course_proposition)[_unref(pages)[current_page_index.value]]
                      )[`${language}_exp_l`]
                    ,
                                          "onUpdate:value": ($event: any) => ((
                      castToExpectedLearningResults(
                        _unref(course_proposition)[_unref(pages)[current_page_index.value]]
                      )[`${language}_exp_l`]
                    ) = $event),
                                          disabled: 
                      action.value == 'view' ||
                      (approved.course &&
                        _unref(ModelProposition).getPropositionProps(
                          'optional'
                        ).indexOf(`${language}_exp_l`) == -1)
                    ,
                                          options: 
                      action.value == 'view' ||
                      (approved.course &&
                        _unref(ModelProposition).getPropositionProps(
                          'optional'
                        ).indexOf(`${language}_exp_l`) == -1)
                        ? {
                            modules: {
                              toolbar: false,
                            },
                            placeholder: false,
                          }
                        : undefined
                    
                                        }, null, 8, ["value", "onUpdate:value", "disabled", "options"])
                                      ]))
                                    : (_unref(pages)[current_page_index.value] == 'criterions')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                          _createElementVNode("b", null, [
                                            _createVNode(_component_ionic_element, {
                                              element: 
                        _unref(getCustomMessage)(
                          `${language}_cri`,
                          _unref(getCurrentElement)(language)
                        )
                      
                                            }, null, 8, ["element"])
                                          ]),
                                          _createVNode(_component_editor_wrapper, {
                                            value: 
                      castToCriterions(
                        _unref(course_proposition)[_unref(pages)[current_page_index.value]]
                      )[`${language}_cri`]
                    ,
                                            "onUpdate:value": ($event: any) => ((
                      castToCriterions(
                        _unref(course_proposition)[_unref(pages)[current_page_index.value]]
                      )[`${language}_cri`]
                    ) = $event),
                                            disabled: 
                      action.value == 'view' ||
                      (approved.course &&
                        _unref(ModelProposition).getPropositionProps(
                          'optional'
                        ).indexOf(`${language}_cri`) == -1)
                    ,
                                            options: 
                      action.value == 'view' ||
                      (approved.course &&
                        _unref(ModelProposition).getPropositionProps(
                          'optional'
                        ).indexOf(`${language}_cri`) == -1)
                        ? {
                            modules: {
                              toolbar: false,
                            },
                            placeholder: false,
                          }
                        : undefined
                    
                                          }, null, 8, ["value", "onUpdate:value", "disabled", "options"])
                                        ]))
                                      : (_unref(pages)[current_page_index.value] == 'activities')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                            _createElementVNode("b", null, [
                                              _createVNode(_component_ionic_element, {
                                                element: 
                        _unref(getCustomMessage)(
                          `${language}_act`,
                          _unref(getCurrentElement)(language)
                        )
                      
                                              }, null, 8, ["element"])
                                            ]),
                                            _createVNode(_component_editor_wrapper, {
                                              value: 
                      castToActivities(
                        _unref(course_proposition)[_unref(pages)[current_page_index.value]]
                      )[`${language}_act`]
                    ,
                                              "onUpdate:value": ($event: any) => ((
                      castToActivities(
                        _unref(course_proposition)[_unref(pages)[current_page_index.value]]
                      )[`${language}_act`]
                    ) = $event),
                                              disabled: 
                      action.value == 'view' ||
                      (approved.course &&
                        _unref(ModelProposition).getPropositionProps(
                          'optional'
                        ).indexOf(`${language}_act`) == -1)
                    ,
                                              options: 
                      action.value == 'view' ||
                      (approved.course &&
                        _unref(ModelProposition).getPropositionProps(
                          'optional'
                        ).indexOf(`${language}_act`) == -1)
                        ? {
                            modules: {
                              toolbar: false,
                            },
                            placeholder: false,
                          }
                        : undefined
                    
                                            }, null, 8, ["value", "onUpdate:value", "disabled", "options"])
                                          ]))
                                        : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  : (_unref(pages)[current_page_index.value] == 'characteristics1')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_unref(IonRow), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonCol), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonInput), {
                                  type: "number",
                                  modelValue: 
                    castToCharacteristics1(
                      _unref(course_proposition)[_unref(pages)[current_page_index.value]]
                    ).credits
                  ,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((
                    castToCharacteristics1(
                      _unref(course_proposition)[_unref(pages)[current_page_index.value]]
                    ).credits
                  ) = $event)),
                                  label: _unref(getCurrentElement)('credits'),
                                  "aria-label": _unref(getCurrentElement)('credits'),
                                  fill: "outline",
                                  class: "ion-margin-vertical",
                                  readonly: action.value == 'view' || approved.course
                                }, null, 8, ["modelValue", "label", "aria-label", "readonly"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonCol), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonInput), {
                                  type: "number",
                                  modelValue: 
                    castToCharacteristics1(
                      _unref(course_proposition)[_unref(pages)[current_page_index.value]]
                    ).up_hours
                  ,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((
                    castToCharacteristics1(
                      _unref(course_proposition)[_unref(pages)[current_page_index.value]]
                    ).up_hours
                  ) = $event)),
                                  label: _unref(getCurrentElement)('up_hours'),
                                  "aria-label": _unref(getCurrentElement)('up_hours'),
                                  fill: "outline",
                                  class: "ion-margin-vertical",
                                  readonly: action.value == 'view' || approved.course
                                }, null, 8, ["modelValue", "label", "aria-label", "readonly"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonRow), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonCol), null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ionic_element, {
                                  element: 
                    _unref(getCustomMessage)(
                      'title',
                      _unref(getCurrentElement)('students_per_section') + ':'
                    )
                  
                                }, null, 8, ["element"]),
                                _createVNode(_unref(IonInput), {
                                  type: "number",
                                  modelValue: 
                    castToCharacteristics1(
                      _unref(course_proposition)[_unref(pages)[current_page_index.value]]
                    ).min_students
                  ,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((
                    castToCharacteristics1(
                      _unref(course_proposition)[_unref(pages)[current_page_index.value]]
                    ).min_students
                  ) = $event)),
                                  label: _unref(getCurrentElement)('min_students'),
                                  "aria-label": _unref(getCurrentElement)('min_students'),
                                  fill: "outline",
                                  class: "ion-margin-vertical",
                                  readonly: action.value == 'view' || approved.course
                                }, null, 8, ["modelValue", "label", "aria-label", "readonly"]),
                                _createVNode(_unref(IonInput), {
                                  type: "number",
                                  modelValue: 
                    castToCharacteristics1(
                      _unref(course_proposition)[_unref(pages)[current_page_index.value]]
                    ).max_students
                  ,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((
                    castToCharacteristics1(
                      _unref(course_proposition)[_unref(pages)[current_page_index.value]]
                    ).max_students
                  ) = $event)),
                                  label: _unref(getCurrentElement)('max_students'),
                                  "aria-label": _unref(getCurrentElement)('max_students'),
                                  fill: "outline",
                                  class: "ion-margin-vertical",
                                  readonly: action.value == 'view' || approved.course
                                }, null, 8, ["modelValue", "label", "aria-label", "readonly"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonCol), null, {
                              default: _withCtx(() => [
                                _createVNode(_component_custom_select, {
                                  selected_option: 
                    castToCharacteristics1(
                      _unref(course_proposition)[_unref(pages)[current_page_index.value]]
                    ).area_id
                  ,
                                  "onUpdate:selected_option": _cache[10] || (_cache[10] = ($event: any) => ((
                    castToCharacteristics1(
                      _unref(course_proposition)[_unref(pages)[current_page_index.value]]
                    ).area_id
                  ) = $event)),
                                  list: _unref(learning_areas),
                                  label: _unref(getCurrentElement)('learning_area') + ':',
                                  aria_label: _unref(getCurrentElement)('learning_area'),
                                  placeholder: _unref(getCurrentElement)('area_choice'),
                                  getCompleteName: learningAreaToString,
                                  disabled: action.value == 'view' || approved.course,
                                  no_padding: true
                                }, null, 8, ["selected_option", "list", "label", "aria_label", "placeholder", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ], 64))
                    : (_unref(pages)[current_page_index.value] == 'characteristics2')
                      ? (_openBlock(), _createBlock(_unref(IonRow), { key: 2 }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_unref(course_proposition).characteristics2), (key) => {
                              return (_openBlock(), _createBlock(_unref(IonCol), { key: key }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ionic_element, {
                                    element: 
                    _unref(getCustomMessage)(
                      'title',
                      _unref(getCurrentElement)(
                        key == 'teaching_list' ? 'teachings' : 'growth_areas'
                      )
                    )
                  
                                  }, null, 8, ["element"]),
                                  (
                    action.value == 'propose' ||
                    (action.value == 'edit' && !approved.course)
                  )
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (key == 'teaching_list')
                                          ? (_openBlock(), _createBlock(_component_custom_select, {
                                              key: trigger.value + '_teachings_select',
                                              selected_option: selected_teaching.value,
                                              "onUpdate:selected_option": _cache[11] || (_cache[11] = ($event: any) => ((selected_teaching).value = $event)),
                                              list: teachings.available,
                                              label: _unref(getCurrentElement)('teaching') + ':',
                                              aria_label: _unref(getCurrentElement)('teaching'),
                                              placeholder: _unref(getCurrentElement)('teaching_choices'),
                                              getCompleteName: getTitle
                                            }, null, 8, ["selected_option", "list", "label", "aria_label", "placeholder"]))
                                          : (_openBlock(), _createBlock(_component_custom_select, {
                                              key: trigger.value + '_growth_areas_select',
                                              selected_option: selected_growth_area.value,
                                              "onUpdate:selected_option": _cache[12] || (_cache[12] = ($event: any) => ((selected_growth_area).value = $event)),
                                              list: growth_areas.available,
                                              label: _unref(getCurrentElement)('growth_area') + ':',
                                              aria_label: _unref(getCurrentElement)('growth_area'),
                                              placeholder: _unref(getCurrentElement)('growth_area_choices'),
                                              getCompleteName: getTitle
                                            }, null, 8, ["selected_option", "list", "label", "aria_label", "placeholder"]))
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (_openBlock(), _createBlock(_component_list_card, {
                                    key: trigger.value + '_list',
                                    cards_list: 
                    key == 'teaching_list'
                      ? teachings_cards
                      : growth_areas_cards
                  ,
                                    emptiness_message: 
                    _unref(getCustomMessage)(
                      'emptiness_message',
                      _unref(getCurrentElement)(
                        key == 'teaching_list'
                          ? 'no_teachings'
                          : 'no_growth_areas'
                      )
                    )
                  ,
                                    onSignal_event: ($event: any) => (
                    removeElement(
                      key == 'teaching_list' ? 'teachings' : 'growth_areas'
                    )
                  )
                                  }, null, 8, ["cards_list", "emptiness_message", "onSignal_event"]))
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : (_unref(pages)[current_page_index.value] == 'access_object')
                        ? (_openBlock(), _createBlock(_unref(IonGrid), { key: 3 }, {
                            default: _withCtx(() => [
                              (
                  action.value == 'propose' || (action.value == 'edit' && !approved.course)
                )
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createVNode(_unref(IonRow), null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(IonCol), null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_custom_select, {
                                              selected_option: selected_learning_context.value,
                                              "onUpdate:selected_option": _cache[13] || (_cache[13] = ($event: any) => ((selected_learning_context).value = $event)),
                                              list: learning_contexts.available,
                                              label: _unref(getCurrentElement)('learning_context') + ':',
                                              aria_label: _unref(getCurrentElement)('learning_context'),
                                              placeholder: 
                        _unref(getCurrentElement)('learning_context_choice')
                      ,
                                              getCompleteName: learningContextToString
                                            }, null, 8, ["selected_option", "list", "label", "aria_label", "placeholder"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_unref(IonCol), null, {
                                          default: _withCtx(() => [
                                            (_openBlock(), _createBlock(_component_custom_select, {
                                              key: trigger.value + '_study_address',
                                              selected_option: selected_study_address.value,
                                              "onUpdate:selected_option": _cache[14] || (_cache[14] = ($event: any) => ((selected_study_address).value = $event)),
                                              list: 
                        study_addresses.available[selected_learning_context.value] ??
                        []
                      ,
                                              label: _unref(getCurrentElement)('study_address') + ':',
                                              aria_label: _unref(getCurrentElement)('study_address'),
                                              placeholder: 
                        selected_learning_context.value != ''
                          ? _unref(getCurrentElement)('study_address_choice')
                          : _unref(getCurrentElement)('learning_context_needed')
                      ,
                                              getCompleteName: studyAddressToString
                                            }, null, 8, ["selected_option", "list", "label", "aria_label", "placeholder"]))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(IonRow), null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(IonCol), null, {
                                          default: _withCtx(() => [
                                            (_openBlock(), _createBlock(_component_custom_select, {
                                              key: trigger.value + '_study_year',
                                              selected_option: selected_study_year.value,
                                              "onUpdate:selected_option": _cache[15] || (_cache[15] = ($event: any) => ((selected_study_year).value = $event)),
                                              list: 
                        study_years.available[selected_learning_context.value] !=
                        undefined
                          ? study_years.available[selected_learning_context.value][
                              selected_study_address.value
                            ] ?? []
                          : []
                      ,
                                              label: _unref(getCurrentElement)('study_year') + ':',
                                              aria_label: _unref(getCurrentElement)('study_year'),
                                              placeholder: 
                        _unref(getCurrentElement)(
                          selected_study_address.value != undefined
                            ? 'study_year_choice'
                            : 'study_address_needed'
                        )
                      
                                            }, null, 8, ["selected_option", "list", "label", "aria_label", "placeholder"])),
                                            _createVNode(_unref(IonCheckbox), {
                                              modelValue: main_study_year.value,
                                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((main_study_year).value = $event)),
                                              "aria-label": _unref(getCurrentElement)('main_study_year'),
                                              class: "ion-padding-start",
                                              "label-placement": "start"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_unref(getCurrentElement)("main_study_year")), 1)
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue", "aria-label"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(IonRow), null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(IonCol), null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(IonButton), {
                                              onClick: _cache[17] || (_cache[17] = ($event: any) => (addElement('access'))),
                                              expand: "block",
                                              fill: "solid"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_unref(getCurrentElement)("add")), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ], 64))
                                : _createCommentVNode("", true),
                              _createVNode(_unref(IonRow), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonCol), null, {
                                    default: _withCtx(() => [
                                      (_openBlock(), _createBlock(_component_list_card, {
                                        key: trigger.value + '_list',
                                        cards_list: access_propositions_cards,
                                        emptiness_message: 
                      _unref(getCustomMessage)(
                        'emptiness_message',
                        _unref(getCurrentElement)('no_access_proposition')
                      )
                    ,
                                        onSignal_event: _cache[18] || (_cache[18] = ($event: any) => (removeElement('access')))
                                      }, null, 8, ["emptiness_message"]))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : (_unref(pages)[current_page_index.value] == 'images_list')
                          ? (_openBlock(), _createBlock(_unref(IonGrid), { key: 4 }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonRow), null, {
                                  default: _withCtx(() => [
                                    (!(action.value != 'view' && images_list.value.length > 0))
                                      ? (_openBlock(), _createBlock(_unref(IonCol), {
                                          key: 0,
                                          size: "3",
                                          class: "ion-hide-md-down"
                                        }))
                                      : _createCommentVNode("", true),
                                    (
                    action.value == 'view' ||
                    (action.value == 'edit' && _unref(user).type == 'admin')
                  )
                                      ? (_openBlock(), _createBlock(_unref(IonCol), {
                                          key: 1,
                                          size: "12",
                                          "size-lg": "6",
                                          class: "ion-text-center"
                                        }, {
                                          default: _withCtx(() => [
                                            (images_list.value.length > 0)
                                              ? (_openBlock(), _createBlock(_component_image_carousel, {
                                                  key: carousel_trigger.value,
                                                  images: images_list.value,
                                                  show_name: !(action.value == 'view' && _unref(user).type == 'teacher')
                                                }, null, 8, ["images", "show_name"]))
                                              : (_openBlock(), _createBlock(_component_ionic_element, {
                                                  key: 1,
                                                  element: 
                      _unref(getCustomMessage)(
                        'no_uploaded_images',
                        _unref(getCurrentElement)('no_uploaded_images'),
                        'string',
                        undefined,
                        {
                          label: {
                            'ion-padding-vertical': true,
                          },
                        }
                      )
                    
                                                }, null, 8, ["element"]))
                                          ]),
                                          _: 1
                                        }))
                                      : (_openBlock(), _createBlock(_unref(IonCol), {
                                          key: 2,
                                          size: "12",
                                          "size-lg": "6"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_image_uploader, {
                                              images_list: images_list.value,
                                              "onUpdate:images_list": _cache[19] || (_cache[19] = ($event: any) => ((images_list).value = $event)),
                                              progress_infos: progress_infos.value,
                                              "onUpdate:progress_infos": _cache[20] || (_cache[20] = ($event: any) => ((progress_infos).value = $event)),
                                              onSignal_event: _cache[21] || (_cache[21] = ($event: any) => (setupModalAndOpen('error')))
                                            }, null, 8, ["images_list", "progress_infos"])
                                          ]),
                                          _: 1
                                        })),
                                    (action.value != 'view' && images_list.value.length > 0)
                                      ? (_openBlock(), _createBlock(_unref(IonCol), {
                                          key: 3,
                                          size: "12",
                                          "size-lg": "6"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ionic_element, {
                                              element: 
                      _unref(getCustomMessage)(
                        'image_visualization_order',
                        _unref(getCurrentElement)('image_visualization_order') + ':'
                      )
                    
                                            }, null, 8, ["element"]),
                                            _createVNode(_unref(IonReorderGroup), {
                                              disabled: approved.project_class || action.value == 'edit',
                                              onIonItemReorder: _cache[23] || (_cache[23] = ($event: any) => (moveImage($event)))
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images_list.value, (image, i) => {
                                                  return (_openBlock(), _createBlock(_unref(IonItem), {
                                                    key: 'order_item_' + i
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ionic_element, {
                                                        element: getReorderLabel(i, image.name, false),
                                                        onSignal_event: _cache[22] || (_cache[22] = ($event: any) => (removeImage()))
                                                      }, null, 8, ["element"]),
                                                      _createVNode(_unref(IonReorder), {
                                                        slot: "end",
                                                        class: "ion-no-margin"
                                                      })
                                                    ]),
                                                    _: 2
                                                  }, 1024))
                                                }), 128))
                                              ]),
                                              _: 1
                                            }, 8, ["disabled"])
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : (_unref(pages)[current_page_index.value] == 'specific_information')
                            ? (_openBlock(), _createBlock(_unref(IonGrid), { key: 5 }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonRow), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(IonCol), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_custom_select, {
                                            selected_option: selected_session.value,
                                            "onUpdate:selected_option": _cache[24] || (_cache[24] = ($event: any) => ((selected_session).value = $event)),
                                            list: _unref(learning_sessions),
                                            label: _unref(getCurrentElement)('learning_sessions') + ':',
                                            aria_label: _unref(getCurrentElement)('learning_sessions'),
                                            placeholder: _unref(getCurrentElement)('learning_sessions_choice'),
                                            getCompleteName: _unref(LearningSession).toString,
                                            disabled: action.value == 'view' || approved.project_class
                                          }, null, 8, ["selected_option", "list", "label", "aria_label", "placeholder", "getCompleteName", "disabled"]),
                                          (_openBlock(), _createBlock(_component_custom_select, {
                                            key: trigger.value,
                                            selected_option: 
                      castToSpecificInformation(
                        _unref(course_proposition)[_unref(pages)[current_page_index.value]]
                      ).class_group
                    ,
                                            "onUpdate:selected_option": _cache[25] || (_cache[25] = ($event: any) => ((
                      castToSpecificInformation(
                        _unref(course_proposition)[_unref(pages)[current_page_index.value]]
                      ).class_group
                    ) = $event)),
                                            list: _unref(groups),
                                            label: _unref(getCurrentElement)('group') + ':',
                                            aria_label: _unref(getCurrentElement)('group'),
                                            placeholder: 
                      _unref(getCurrentElement)(
                        selected_session.value == -1
                          ? 'learning_session_needed'
                          : 'group_choice'
                      )
                    ,
                                            disabled: action.value == 'view' || approved.project_class
                                          }, null, 8, ["selected_option", "list", "label", "aria_label", "placeholder", "disabled"])),
                                          (_unref(sections_use))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                                _createVNode(_unref(IonInput), {
                                                  type: "number",
                                                  modelValue: num_section.value,
                                                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((num_section).value = $event)),
                                                  label: _unref(getCurrentElement)('num_section'),
                                                  "aria-label": _unref(getCurrentElement)('num_section'),
                                                  fill: "outline",
                                                  readonly: action.value == 'view' || approved.project_class
                                                }, null, 8, ["modelValue", "label", "aria-label", "readonly"])
                                              ]))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("div", _hoisted_9, [
                                            _createVNode(_unref(IonInput), {
                                              type: "text",
                                              modelValue: 
                        castToSpecificInformation(
                          _unref(course_proposition)[_unref(pages)[current_page_index.value]]
                        ).project_class_code
                      ,
                                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((
                        castToSpecificInformation(
                          _unref(course_proposition)[_unref(pages)[current_page_index.value]]
                        ).project_class_code
                      ) = $event)),
                                              label: _unref(getCurrentElement)('project_class_code'),
                                              "aria-label": _unref(getCurrentElement)('project_class_code'),
                                              fill: "outline",
                                              maxlength: 
                        castAsArray(
                          _unref(ModelProposition).getRequiredInformation()
                            .project_class_code[0].rule
                        )[0]
                      ,
                                              readonly: action.value == 'view' || approved.project_class
                                            }, null, 8, ["modelValue", "label", "aria-label", "maxlength", "readonly"])
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(IonCol), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ionic_element, {
                                            element: 
                      _unref(getCustomMessage)(
                        'teachers_title',
                        _unref(getCurrentElement)('teachers')
                      )
                    
                                          }, null, 8, ["element"]),
                                          (action.value != 'view')
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createElementVNode("div", null, [
                                                  (_openBlock(), _createBlock(_component_custom_select, {
                                                    key: trigger.value + '_teacher',
                                                    selected_option: selected_teacher.value,
                                                    "onUpdate:selected_option": _cache[28] || (_cache[28] = ($event: any) => ((selected_teacher).value = $event)),
                                                    list: teachers.available,
                                                    label: _unref(getCurrentElement)('teacher') + ':',
                                                    aria_label: _unref(getCurrentElement)('teacher'),
                                                    placeholder: _unref(getCurrentElement)('teacher_choice'),
                                                    getCompleteName: teacherToString
                                                  }, null, 8, ["selected_option", "list", "label", "aria_label", "placeholder"]))
                                                ]),
                                                (_unref(sections_use))
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                      _createVNode(_unref(IonText), { class: "ion-padding" }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(_unref(getCurrentElement)("sections")) + ": " + _toDisplayString(num_section.value == "" || parseInt(num_section.value) <= 0
                            ? _unref(getCurrentElement)("num_section_needed")
                            : ""), 1)
                                                        ]),
                                                        _: 1
                                                      }),
                                                      (num_section.value != '' && parseInt(num_section.value) > 0)
                                                        ? (_openBlock(), _createBlock(_unref(IonList), { key: 0 }, {
                                                            default: _withCtx(() => [
                                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sections), (value, index) => {
                                                                return (_openBlock(), _createBlock(_unref(IonItem), {
                                                                  key: _unref(numberToSection)(index)
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_unref(IonCheckbox), {
                                                                      modelValue: _unref(sections)[index],
                                                                      "onUpdate:modelValue": ($event: any) => ((_unref(sections)[index]) = $event),
                                                                      "aria-label": _unref(numberToSection)(index),
                                                                      class: "ion-padding-start",
                                                                      "label-placement": "start"
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(_unref(numberToSection)(index)), 1)
                                                                      ]),
                                                                      _: 2
                                                                    }, 1032, ["modelValue", "onUpdate:modelValue", "aria-label"])
                                                                  ]),
                                                                  _: 2
                                                                }, 1024))
                                                              }), 128))
                                                            ]),
                                                            _: 1
                                                          }))
                                                        : _createCommentVNode("", true)
                                                    ], 64))
                                                  : _createCommentVNode("", true)
                                              ], 64))
                                            : _createCommentVNode("", true),
                                          (_unref(sections_use) && action.value == 'propose')
                                            ? (_openBlock(), _createBlock(_unref(IonButton), {
                                                key: 1,
                                                onClick: _cache[29] || (_cache[29] = ($event: any) => (addElement('teachers'))),
                                                expand: "block",
                                                fill: "solid"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_unref(getCurrentElement)("add")), 1)
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          (_openBlock(), _createBlock(_component_list_card, {
                                            key: trigger.value + '_list',
                                            cards_list: teachers_cards,
                                            emptiness_message: 
                      _unref(getCustomMessage)(
                        'emptiness_message',
                        _unref(getCurrentElement)('no_teacher_proposition')
                      )
                    ,
                                            onSignal_event: _cache[30] || (_cache[30] = ($event: any) => (removeElement('teachers')))
                                          }, null, 8, ["emptiness_message"]))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                _createVNode(_unref(IonRow), {
                  class: "ion-text-center",
                  style: {"border-top":"1px solid var(--ion-color-dark)"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCol), null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ionic_element, {
                          element: buttons[0],
                          onSignal_event: _cache[31] || (_cache[31] = ($event: any) => (go(false))),
                          disabled: current_page_index.value == 0
                        }, null, 8, ["element", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonCol), null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ionic_element, {
                          element: buttons[1],
                          onSignal_event: _cache[32] || (_cache[32] = ($event: any) => (go(true))),
                          disabled: current_page_index.value == _unref(pages).length - 1
                        }, null, 8, ["element", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonRow), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCol), null, {
                      default: _withCtx(() => [
                        (action.value == 'propose')
                          ? (_openBlock(), _createBlock(_unref(IonButton), {
                              key: 0,
                              onClick: checkAndConfirm,
                              expand: "block",
                              fill: "solid"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(getCurrentElement)("propose")), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }))
  ]))
}
}

})